import { render, staticRenderFns } from "./conversation-profile.vue?vue&type=template&id=2bcda9d6&scoped=true&"
import script from "./conversation-profile.vue?vue&type=script&lang=js&"
export * from "./conversation-profile.vue?vue&type=script&lang=js&"
import style0 from "./conversation-profile.vue?vue&type=style&index=0&id=2bcda9d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcda9d6",
  null
  
)

export default component.exports